export const getEntityOptionKey = <T extends { _id: string }>(entity: T): string => entity._id;

export const isEntityOptionEqual = <T extends { _id: string }>(option: T, value: T): boolean =>
  option._id === value._id;

export const findEntityById = <T extends { _id: string }>(
  entities: T[],
  entityId: string,
): T | null => entities.find((entity) => entity._id === entityId) || null;
